import page from '../utils/rbata.page';

const facetOverlay = {
    pageBody: undefined,
    cacheSelectors() {
        this.pageBody = $(document.body);
    },
    close() {
        $('.facet__overlay--visible').removeClass('facet__overlay--visible');
        page.addBackdrop(false, this.pageBody);
        this.pageBody.off('click.facetOverlay');
    },
    bindHandler() {
        this.pageBody.on('click', '#js-open-facet-overlay', (evt) => {
            const self = evt.currentTarget;

            $(self.dataset.target).addClass('facet__overlay--visible');
            page.addBackdrop(true, this.pageBody);

            // close facet overlay by clicking the grey out area
            this.pageBody.on('click.facetOverlay', evt => {
                if ($(evt.target).hasClass('page--greyout')) {
                    this.close();
                }
            });
        });
        this.pageBody.on('click', '.js-close-facet-overlay', () => {
            this.close();
        });
    }
};

$(() => {
    if ($('#product-grid-page').length) {
        facetOverlay.cacheSelectors();
        facetOverlay.bindHandler();
    }
});

export default facetOverlay;
